import { TableCell, TableHead, TableRow } from '@mui/material';

export default function MileageTableHead() {
    return (
        <TableHead>
            <TableRow>
                <TableCell sx={{ pl: 0 }}>EXPENSE</TableCell>
                <TableCell align="right">DRIVEN MILES</TableCell>
                <TableCell />
                <TableCell align="right">MULTIPLIER</TableCell>
                <TableCell />
                <TableCell align="right" sx={{ pr: 0 }}>
                    REIMBURSABLE
                </TableCell>
            </TableRow>
        </TableHead>
    );
}
